<template>
  <svg
    width="82"
    height="44"
    viewBox="0 0 82 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1C0 0.447715 0.447715 0 1 0H24C24.5523 0 25 0.447715 25 1V11C25 11.5523 24.5523 12 24 12H1C0.447716 12 0 11.5523 0 11V1Z"
    />
    <path
      d="M29 1C29 0.447715 29.4477 0 30 0H52C52.5523 0 53 0.447715 53 1V11C53 11.5523 52.5523 12 52 12H30C29.4477 12 29 11.5523 29 11V1Z"
    />
    <path
      d="M57 1C57 0.447715 57.4477 0 58 0H81C81.5523 0 82 0.447715 82 1V11C82 11.5523 81.5523 12 81 12H58C57.4477 12 57 11.5523 57 11V1Z"
    />
    <path
      d="M0 17C0 16.4477 0.447715 16 1 16H24C24.5523 16 25 16.4477 25 17V27C25 27.5523 24.5523 28 24 28H1C0.447716 28 0 27.5523 0 27V17Z"
    />
    <path
      d="M29 17C29 16.4477 29.4477 16 30 16H52C52.5523 16 53 16.4477 53 17V27C53 27.5523 52.5523 28 52 28H30C29.4477 28 29 27.5523 29 27V17Z"
    />
    <path
      d="M57 17C57 16.4477 57.4477 16 58 16H81C81.5523 16 82 16.4477 82 17V27C82 27.5523 81.5523 28 81 28H58C57.4477 28 57 27.5523 57 27V17Z"
    />
    <path
      d="M0 33C0 32.4477 0.447715 32 1 32H24C24.5523 32 25 32.4477 25 33V43C25 43.5523 24.5523 44 24 44H1C0.447716 44 0 43.5523 0 43V33Z"
    />
    <path
      d="M29 33C29 32.4477 29.4477 32 30 32H52C52.5523 32 53 32.4477 53 33V43C53 43.5523 52.5523 44 52 44H30C29.4477 44 29 43.5523 29 43V33Z"
    />
    <path
      d="M57 33C57 32.4477 57.4477 32 58 32H81C81.5523 32 82 32.4477 82 33V43C82 43.5523 81.5523 44 81 44H58C57.4477 44 57 43.5523 57 43V33Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ActiveBasicLayoutIcon",
};
</script>
